module.exports = __webpack_public_path__ + "static/media/pdf.cbd2da69.png";